import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export function ActivateHeader() {
  return (
    <Box>
      <Typography sx={{ textTransform: 'uppercase', fontWeight: 'medium' }} gutterBottom color="text.secondary">
        Activate account
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: 700 }}>
        Set your password
      </Typography>
      <Typography color="text.secondary">Create a secure password to activate your account and get started.</Typography>
    </Box>
  );
}

export default ActivateHeader;
